var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Duo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14646 2.2334C6.85098 2.2334 5.80078 3.28359 5.80078 4.57908C5.80078 5.87456 6.85098 6.92476 8.14646 6.92476C9.44194 6.92476 10.4921 5.87456 10.4921 4.57908C10.4921 3.28359 9.44194 2.2334 8.14646 2.2334ZM4.30078 4.57908C4.30078 2.45517 6.02255 0.733398 8.14646 0.733398C10.2704 0.733398 11.9921 2.45517 11.9921 4.57908C11.9921 6.70299 10.2704 8.42476 8.14646 8.42476C6.02255 8.42476 4.30078 6.70299 4.30078 4.57908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20508 14.4853C1.20508 12.0195 3.20404 10.0205 5.66989 10.0205H10.623C13.0888 10.0205 15.0878 12.0195 15.0878 14.4853C15.0878 16.2673 13.6432 17.7119 11.8612 17.7119H4.43162C2.64965 17.7119 1.20508 16.2673 1.20508 14.4853ZM5.66989 11.5205C4.03247 11.5205 2.70508 12.8479 2.70508 14.4853C2.70508 15.4389 3.47808 16.2119 4.43162 16.2119H11.8612C12.8148 16.2119 13.5878 15.4389 13.5878 14.4853C13.5878 12.8479 12.2604 11.5205 10.623 11.5205H5.66989Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutline);
export default __webpack_public_path__ + "static/media/PersonOutline.b1a9332d3b076ab4de8c405b67babdb1.svg";
export { ForwardRef as ReactComponent };